/**
 * Hooks are the only callers of the API client (§5).
 *
 * Phase 0 ships one: it confirms the token verified and reports which farm the
 * API resolved the caller to. The domain hooks listed in §4 arrive with their
 * routes in Phase 1.
 */
import { useQuery } from '@tanstack/react-query'
import { ApiRequestError, api } from '../lib/api-client'
import { useSession } from '../store/session'

export interface SessionInfo {
  userId: string
  farmId: string
  role: string
}

export function useSessionInfo() {
  const session = useSession()
  return useQuery({
    queryKey: ['session', session.accessToken],
    queryFn: ({ signal }) => api.get<SessionInfo>('/session', signal),
    enabled: session.accessToken !== null,
    staleTime: 5 * 60 * 1000,
    // A user with no farm goes to setup; asking again will not change the answer.
    retry: (failures, error) => !isNoFarm(error) && failures < 1,
  })
}

/** The API's answer for a signed-in user who has not set up a farm yet. */
export function isNoFarm(error: unknown): boolean {
  return error instanceof ApiRequestError && error.code === 'no_farm'
}
